/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveLocationGroups from './receive-location-groups';
import * as actions from 'state/action-types';

export default (locationGroupId = null, locationGroup) => (dispatch) => {
    const isNew = !locationGroupId;
    if (isNew) {
        return cecSdk
            .locationGroup()
            .add(locationGroup)
            .then((locationGroup) => {
                dispatch(receiveLocationGroups([locationGroup]));
                dispatch({ type: actions.SAVE_LOCATION_GROUP_SUCCESS, payload: { locationGroup, isNew } });
            });
    }

    return cecSdk
        .locationGroup(locationGroupId)
        .update(locationGroup)
        .then((locationGroup) => {
            dispatch(receiveLocationGroups([locationGroup]));
            dispatch({ type: actions.SAVE_LOCATION_GROUP_SUCCESS, payload: { locationGroup } });
        });
};